// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenu_aside__XMfTk {
  width: 30rem;
  flex-shrink: 0;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 0.8rem;
  padding-block: 2.1rem;
}

.SideMenu_aside__header__G6Cc6 {
  color: var(--primary-color);
  font-size: var(--text-xl);
  font-weight: 700;
  margin-bottom: 4rem;
  padding-inline-start: 2rem;
}

.SideMenu_aside__list__q6iJz {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  margin-bottom: 3.5rem;
}

.SideMenu_aside__list-item-link__hl9Vy {
  display: block;
  padding-inline-start: 2rem;
  padding-block: 1.2rem;
}

.SideMenu_aside__list-item-link--active__Bjz2R {
  background-color: var(--sky);
  border-radius: 0.8rem;
}

.SideMenu_aside__logout-wrapper__idTiO {
  padding-inline-start: 5.2rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .SideMenu_aside__XMfTk {
    width: 25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/SideMenu/SideMenu.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".aside {\n  width: 30rem;\n  flex-shrink: 0;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 0.8rem;\n  padding-block: 2.1rem;\n}\n\n.aside__header {\n  color: var(--primary-color);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  margin-bottom: 4rem;\n  padding-inline-start: 2rem;\n}\n\n.aside__list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n  margin-bottom: 3.5rem;\n}\n\n.aside__list-item-link {\n  display: block;\n  padding-inline-start: 2rem;\n  padding-block: 1.2rem;\n}\n\n.aside__list-item-link--active {\n  background-color: var(--sky);\n  border-radius: 0.8rem;\n}\n\n.aside__logout-wrapper {\n  padding-inline-start: 5.2rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .aside {\n    width: 25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aside": `SideMenu_aside__XMfTk`,
	"aside__header": `SideMenu_aside__header__G6Cc6`,
	"aside__list": `SideMenu_aside__list__q6iJz`,
	"aside__list-item-link": `SideMenu_aside__list-item-link__hl9Vy`,
	"aside__list-item-link--active": `SideMenu_aside__list-item-link--active__Bjz2R`,
	"aside__logout-wrapper": `SideMenu_aside__logout-wrapper__idTiO`
};
export default ___CSS_LOADER_EXPORT___;
